import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { brandPrimary, error, header, label } from '../../../styles/colors';

const { spacing, common } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		maxWidth: 600,
		alignItems: 'center',
		paddingLeft: 200,
		paddingRight: 200,
	},
	tabView: {
		width: '100%',
	},
	tabViewTabs: {
		display: 'flex',
		borderBottom: common.border,
	},
	tabViewItem: {
		color: header,
		display: 'inline-flex',
		flexBasis: 'auto',
		fontSize: 14,
		height: spacing.xxl,
		paddingTop: spacing.none,
		paddingBottom: spacing.none,
		paddingLeft: spacing.xl,
		paddingRight: spacing.xl,
		textAlign: 'center',
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
		gap: spacing.sm,
	},
	tabItemSelected: {
		borderBottom: `1px solid ${brandPrimary}`,
	},
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		alignItems: 'center',
		padding: spacing.md,
	},
	signInContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		alignItems: 'center',
	},
	signInForm: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	inputWrapper: {
		width: 300,
	},
	signInFormField: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
		margin: 0,
		width: 300,
	},
	textInput: {
		width: '100%',
	},
	signInFormFieldLabel: {
		color: label,
		display: 'block',
		fontSize: 14,
		lineHeight: '22px',
	},
	signInFormFieldError: {
		color: error,
		display: 'block',
		fontSize: 13,
		lineHeight: '18px',
		marginTop: 4,
	},
});
